import * as Config from '../config';
import isUndefined from 'lodash/isUndefined';

export default class FitText {
    constructor({el}) {
        this.el = el;
        this.alias = this.el.getAttribute('data-module-alias') || 'header';
        if (this.alias === 'tagline') {
            return;
        }

        this.options = {
            header: {
                sizes: [600, 900, 1200, 1400, 1600]
            },
            tagline: {
                sizes: [160, 240, 320, 360, 400]
            }
        };
        
        this.bind();
        this.resize();
        return;

        const scale = el.getAttribute('data-module-scale');
        const max = el.getAttribute('data-module-max');

        this.node = document.createElement('span');

        this.node.style.position = 'absolute';
        this.node.style.visibility = 'hidden';
        this.node.style.height = 'auto';
        this.node.style.width = 'auto';
        this.node.style.whiteSpace = 'nowrap';

        document.body.appendChild(this.node);

        if (scale !== null) {
            options.scale = parseFloat(scale);
        }

        if (max !== null) {
            options.max = parseFloat(max);
        }

        this.el = el;
        this.options = {
            ...{
                scale: 0.6,
                min: 12,
                max: 200
            },
            ...options
        };
        this.styles = window.getComputedStyle(this.el);

        this.node.style.fontFamily = this.styles.fontFamily;
        this.node.style.fontSize = this.styles.fontSize;
        this.node.innerHTML = this.el.innerHTML;

        this.options.maxWidth = this.el.offsetWidth;
        this.options.fs = parseInt(this.styles.fontSize, 10);

        this.resize();
    }

    resize() {
        const bp = Config.get('breakpoint');
        const sizes = this.options[this.alias].sizes;
        const weight = !isUndefined(sizes[bp]) ? sizes[bp] : sizes[(sizes.length - 1)];
        const chars = this.el.innerHTML.length;
        const pixels = Math.floor(weight / chars);

        

        this.el.style.fontSize = `${pixels}px`;
    }

    bind() {
        window.addEventListener('resize', evt => {
            this.resize();
        });

        window.addEventListener('orientationchange', evt => {
            this.resize();
        });
    }
}
